import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ChatbotFlowsAPI from '../../api/chatbotFlows';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getChatbotFlows(_state) {
    return _state.records.sort((a1, a2) => a1.id - a2.id);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getChatbotFlow: _state => id => {
    return _state.records.find(r => r.id === Number(id));
  },
};

export const actions = {
  get: async function getChatbotFlows({ commit }) {
    commit(types.SET_CHATBOT_FLOW_UI_FLAG, { isFetching: true });
    try {
      const response = await ChatbotFlowsAPI.get();
      commit(types.SET_CHATBOT_FLOWS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CHATBOT_FLOW_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createChatbotFlow({ commit }, flowObj) {
    commit(types.SET_CHATBOT_FLOW_UI_FLAG, { isCreating: true });
    try {
      const response = await ChatbotFlowsAPI.create(flowObj);
      commit(types.ADD_CHATBOT_FLOW, response.data.payload);
      return response.data.payload;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CHATBOT_FLOW_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_CHATBOT_FLOW_UI_FLAG, { isUpdating: true });
    try {
      const response = await ChatbotFlowsAPI.update(id, updateObj);
      commit(types.EDIT_CHATBOT_FLOW, response.data.payload);
      return response.data.payload;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CHATBOT_FLOW_UI_FLAG, { isUpdating: false });
    }
  },
  clone: async ({ commit }, id) => {
    try {
      const response = await ChatbotFlowsAPI.clone(id);
      commit(types.ADD_CHATBOT_FLOW, response.data.payload);
      return response.data.payload;
    } catch (error) {
      throw new Error(error);
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CHATBOT_FLOW_UI_FLAG, { isDeleting: true });
    try {
      await ChatbotFlowsAPI.delete(id);
      commit(types.DELETE_CHATBOT_FLOW, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CHATBOT_FLOW_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CHATBOT_FLOW_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.ADD_CHATBOT_FLOW]: MutationHelpers.create,
  [types.SET_CHATBOT_FLOWS]: MutationHelpers.set,
  [types.EDIT_CHATBOT_FLOW]: MutationHelpers.update,
  [types.DELETE_CHATBOT_FLOW]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
